import { parseStyles, stringifyStyles } from '@common/html/util/style';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttr } from '@common/util/schema';
import { MarkSpec, Node, NodeSpec } from 'prosemirror-model';

const styleAttrName = 'style';

export class MadCapStyleSchemaPlugin extends SchemaPlugin {
  modifyNodesAndMarks(nodes: Dictionary<NodeSpec>, marks: Dictionary<MarkSpec>) {
    Object.entries(nodes).forEach(([name, nodeSpec]) => {
      if (name !== 'text') {
        nodeSpec.attrs = Object.assign(nodeSpec.attrs ?? {}, {
          class: {
            default: undefined,
            toEditorAttr: (value: Dictionary<string>, node: Node) => {
              return node.type.spec.noStyles ? {} : { class: value };
            }
          },
          [styleAttrName]: {
            default: undefined,
            toFlareXML: (value: Dictionary<string>) => {
              return (typeof value === 'object' && value !== null) ? stringifyStyles(value) : value;
            },
            toEditorAttr: (value: Dictionary<string>) => {
              // The style attribute is rendered by node decorations in flareComputedStylesheetPlugin so return empty attributes here
              return {};
            }
          }
        });

        if (Array.isArray(nodeSpec.parseDOM)) {
          nodeSpec.parseDOM.forEach(parser => {
            const originalGetAttrs = parser.getAttrs;

            parser.getAttrs = function (dom: Element) {
              let attrs = originalGetAttrs ? originalGetAttrs.apply(this, arguments) : {};

              if (attrs === false) {
                return false;
              }

              const classAttr = getSchemaAttr(dom, 'class');
              if (classAttr) {
                attrs = attrs ?? {}; // Ensure attrs exists
                attrs['class'] = classAttr;
              }

              const style = getSchemaAttr(dom, styleAttrName);
              if (style) {
                attrs = attrs ?? {}; // Ensure attrs exists
                attrs[styleAttrName] = parseStyles(style);
              }

              return attrs;
            };
          });
        }
      }
    });
  }
}
